module.exports = __webpack_public_path__ + "media/books/Books-Focus-2-93fd1e6e.png";